import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
const RESIZE_DIRECTIONS = ["none", "vertical", "horizontal", "both"];
const textAreaVariants = cva(cn(
// 16px on small viewports so Mobile Safari does not zoom on focus.
"flex w-full px-3 py-2 text-base md:text-sm", "text-foreground", "bg-muted-background", "placeholder:text-muted-foreground", "ring-offset-background", "border border-border rounded-xl transition duration-100 focus-visible:outline-hidden", "focus-visible:border-border focus-visible:ring"), {
    variants: {
        resize: {
            none: "resize-none",
            vertical: "resize-y",
            horizontal: "resize-x",
            both: "resize",
        },
        error: {
            true: cn("border-border-warning/30", "ring-warning/0", "focus-visible:border-border-warning", "focus-visible:outline-hidden focus-visible:ring-2", "focus-visible:ring-warning/10"),
            false: cn("border-border", "ring-highlight/0", "focus-visible:border-border-focus", "focus-visible:outline-hidden focus-visible:ring-2", "focus-visible:ring-highlight/20"),
        },
        disabled: {
            true: cn("disabled:cursor-not-allowed", "disabled:text-muted-foreground"),
            false: "",
        },
        isDisplay: {
            true: "cursor-default",
            false: "",
        },
    },
    defaultVariants: {
        resize: "both",
        error: false,
        disabled: false,
        isDisplay: false,
    },
});
/**
 * A multi-line text field for longer freeform input such as a prompt, instructions, or a
 * comment, with validation via `error` / `showErrorLabel`, a `disabled` state, and a
 * read-only `isDisplay` rendering. Use it to collect or display text spanning multiple
 * lines; for a single line of text such as a name or email use `Input`, and for search
 * use `SearchInput`.
 *
 * @summary Multi-line text field.
 */
const TextArea = React.forwardRef(({ className, id, resize, minRows = 10, error, showErrorLabel, disabled, isDisplay, ...props }, ref) => {
    return (React.createElement("div", { className: "flex flex-col gap-1 p-px" },
        React.createElement("textarea", { id: id, className: cn(textAreaVariants({
                resize,
                error: !!error,
                disabled,
                isDisplay,
                className,
            })), ref: ref, rows: minRows, disabled: disabled, ...props }),
        error && showErrorLabel && (React.createElement("div", { className: "ml-2 text-xs text-warning-500" }, error))));
});
TextArea.displayName = "TextArea";
const ReadOnlyTextArea = ({ content, minRows = 10, }) => {
    return (React.createElement(TextArea, { disabled: true, isDisplay: true, minRows: minRows, className: cn("text-base font-normal md:text-sm h-full min-h-60 w-full min-w-0 rounded-xl", "resize-none border-border bg-muted-background"), defaultValue: content !== null && content !== void 0 ? content : "" }));
};
export { ReadOnlyTextArea, TextArea };
//# sourceMappingURL=TextArea.js.map